import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles, the } from './customStyles';

const MarketDropdown = ({ allScripts, onMarketChange, onScriptReset, value }) => {
    const [market, setMarket] = useState([]);
    const [internalSelected, setInternalSelected] = useState('');

    // Use the controlled `value` prop when provided; otherwise fall back to internal state.
    // This keeps the dropdown display in sync without requiring every parent to pass `value`.
    const selectedMarket = value !== undefined ? value : internalSelected;

    useEffect(() => {
        const marketData = [];
        for (const category in allScripts) {
            marketData.push({ label: category, value: category });
        }
        setMarket(marketData);
    }, [allScripts]);

    const handleMarketDropdown = (selectedOption) => {
        if (selectedOption) {
            setInternalSelected(selectedOption.value);
            onMarketChange(selectedOption.value);
            onScriptReset();
        } else {
            setInternalSelected(null);
            onMarketChange(null);
            onScriptReset();
        }
    };

    return (
        <Col>
            <Select
                options={market}
                value={market.find(mkt => mkt.value === selectedMarket) || null}
                onChange={handleMarketDropdown}
                isMulti={false}
                isClearable
                placeholder="Select"
                theme={the}
                styles={customStyles}
            />
        </Col>
    );
};

export default MarketDropdown;
